const optionMenu = document.querySelector(".select-menu");

if (optionMenu) {
  const selectBtn = optionMenu.querySelector(".select-btn");
  const options = optionMenu.querySelectorAll(".option");
  const sBtn_text = optionMenu.querySelector(".sBtn-text");

  if (selectBtn) {
    selectBtn.addEventListener("click", () =>
      optionMenu.classList.toggle("active")
    );
  }

  if (options.length > 0) {
    options.forEach((option) => {
      option.addEventListener("click", () => {
        let selectedOption = option.querySelector(".option-text").innerText;
        sBtn_text.innerText = selectedOption;

        optionMenu.classList.remove("active");
      });
    });
  }
}
